/*内外网配置*/
export let obsConfig = {};
// if (localStorage.getItem("__network__") == 'true') { //true外网
//     //华为云obs配置
//     obsConfig = {
//         ak: "9RKWDCLM1AMBIZUDF70S",
//         sk: "U5iCIxBVwrIkgax7nI7R2WTzS9aYaUsjpEgYHll8",
//         urlserver: "obs.cn-north-1.myhuaweicloud.com",
//         BucketName: "bcxin-v5-prod"
//     }
// } else {
//     //华为云obs配置
//     obsConfig = {
//         ak: "9RKWDCLM1AMBIZUDF70S",
//         sk: "U5iCIxBVwrIkgax7nI7R2WTzS9aYaUsjpEgYHll8",
//         urlserver: "obs.cn-north-1.myhuaweicloud.com",
//         BucketName: "wqj-test"
//     }
// }

if(localStorage.getItem("__isDev__") == 'true'){
    obsConfig = {
        ak: "YYSIHHGD8VTNTQVA2NCB",
        sk: "fd3My9hE8N7Byl4SJ8Mx0kKcn7gvaZoh506WGC0y",
        urlserver: "obs.cn-north-1.myhuaweicloud.com",
        BucketName: "bcxin-saas-test",
        CDN_POINT: "https://bcxinsaasprod.baibaodun.cn",
    }
}else{
    obsConfig = {
        ak: "YYSIHHGD8VTNTQVA2NCB",
        sk: "fd3My9hE8N7Byl4SJ8Mx0kKcn7gvaZoh506WGC0y",
        urlserver: "obs.cn-north-1.myhuaweicloud.com",
        BucketName: "bcxin-saas-prod",
        CDN_POINT: "https://bcxinsaasprod.baibaodun.cn",
    }
}

// 翔云OCR配置
export const xiangyunKey = {
    key: "Es1TRT94hJsvSttv9GLhy4",
    secret: "19d6be2e3e164f98a1b7d1321a73189c"
}